import React, { useLayoutEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "./Research.css";

gsap.registerPlugin(ScrollTrigger);

const Research = () => {
    const containerRef = useRef(null);
    const researchTopics = [
        {
            title: "The Rise of Large Language Models (LLMs)",
            description:
                "LLMs like GPT-3 and Megatron-Turing NLG have revolutionized NLP, enabling better chatbots, writing assistants, and AI-driven content generation.",
        },
        {
            title: "Advances in Computer Vision",
            description:
                "Deep learning has improved object detection, image segmentation, and facial recognition, making AI-powered vision more precise.",
        },
        {
            title: "Reinforcement Learning and AI Decision Making",
            description:
                "DeepMind’s AlphaFold and OpenAI’s Dota 2 bot showcase how reinforcement learning is solving complex decision-making problems.",
        },
        {
            title: "Federated Learning for Privacy-Preserving AI",
            description:
                "Federated learning enables AI training across multiple devices without sharing private data, enhancing security.",
        },
        {
            title: "Towards Explainable AI",
            description:
                "As AI grows more complex, making models interpretable and transparent remains a key challenge in responsible AI development.",
        },
    ];

    useLayoutEffect(() => {
        let ctx;
        // Small delay to ensure ScrollToTop has completed and DOM is settled
        const timer = setTimeout(() => {
            ctx = gsap.context(() => {
                // Hero Animation
                gsap.from(".research-hero > *", {
                    y: 30,
                    opacity: 0,
                    duration: 1,
                    stagger: 0.2,
                    ease: "power3.out"
                });

                // Card Animation - Batching for better scroll performance
                // Using batch ensures elements that are entered are animated
                ScrollTrigger.batch(".research-card", {
                    onEnter: (elements) => {
                        gsap.from(elements, {
                            y: 60,
                            opacity: 0,
                            duration: 0.8,
                            stagger: 0.15,
                            ease: "back.out(1.2)",
                            overwrite: true
                        });
                    },
                    once: true,
                    start: "top 90%" // Trigger a bit earlier to ensure they appear
                });
            }, containerRef);
            ScrollTrigger.refresh();
        }, 100);

        return () => {
            clearTimeout(timer);
            if (ctx) ctx.revert();
        };
    }, []);

    return (
        <div className="research-container" ref={containerRef}>
            <section className="research-hero">
                <h1>Breakthroughs in AI, Deep Learning & Machine Learning</h1>
                <p>Explore the latest innovations shaping the future of artificial intelligence.</p>
            </section>

            <section className="research-grid">
                {researchTopics.map((topic, index) => (
                    <div key={index} className="research-card glass-panel">
                        <span className="research-index">0{index + 1}</span>
                        <h3>{topic.title}</h3>
                        <p>{topic.description}</p>
                    </div>
                ))}
            </section>

            <footer className="research-footer">
                <p>&copy; 2024 Galilee Research - AI & Cloud Innovation</p>
            </footer>
        </div>
    );
};

export default Research;
